module.exports = __webpack_public_path__ + "assets/img/2.3f52f4e1.jpg";